import { STATUS_CARD, HAN_THE_OPTIONS } from "assets/constants/card-types";
import { validateMaxMin } from "helper/validate";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";

const {
  INPUT,
  DATE,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  DATE_ON,
  NUMBER,
  CHECKBOX,
  RADIO,
  NORMAL_CHECKBOX,
  COMBO_BOX,
} = FIELD_TYPE;

const cssProps = {
  labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
  wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  css: { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 },
};

const cssProps2 = {
  labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
  wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
};
const dataFields = [
  {
    type: INPUT,
    name: "maLoaiThe",
    label: "Loại thẻ",
    allowClear: true,
    ...cssProps,
  },
  {
    type: SELECT,
    name: "trangThai",
    label: "Trạng thái",
    options: STATUS_CARD,
    allowClear: true,
    ...cssProps,
  },
  // {
  //   type: DATE,
  //   name: 'apDungTuNgay',
  //   label: "Áp dụng từ ngày",
  //   ...cssProps
  // },
  // {
  //   type: DATE,
  //   name: 'apDungDenNgay',
  //   label: 'Áp dụng đến ngày',
  //   ...cssProps
  // },
  {
    type: SELECT,
    name: "thoiHan",
    label: "Hạn thẻ",
    options: HAN_THE_OPTIONS,
    allowClear: true,
    ...cssProps,
  },
];
const cardTypesInfo = [
  {
    name: "id",
    type: INPUT,
    hide: true,
  },
  // {
  //   type: INPUT,
  //   name: 'maLoaiThe',
  //   label: "Loại thẻ",
  //   ...cssProps2
  // },
  // {
  //   type: INPUT,
  //   name: 'tenLoaiThe',
  //   label: 'Tên loại thẻ',
  //   ...cssProps2
  // },
  {
    label: "Giá bán",
    type: CURRENCY,
    name: "giaBan",
    placeHolder: "Nhập",
    disabled: true,
    ...cssProps2,
  },
  {
    name: "trangThai",
    hide: true,
  },
  {
    label: "Thời hạn (tháng)",
    name: "thoiHan",
    type: NUMBER,
    disabled: true,
    ...cssProps2,
  },
  {
    label: "Điều kiện khác",
    name: "dieuKienKhac",
    type: INPUT,
    disabled: true,
    ...cssProps2,
  },
  {
    label: "Ghi chú",
    name: "ghiChu",
    type: INPUT,
    disabled: true,
    ...cssProps2,
  },
  {
    type: NORMAL_CHECKBOX,
    label: "Thẻ gia đình",
    name: "theGiaDinh",
    valuePropName: "checked",
    disabled: true,
    ...cssProps2,
  },
];

const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (v, r, i) => i + 1,
    align: "center",
  },
  {
    title: "Mã loại thẻ",
    dataIndex: "maLoaiThe",
    show: true,
    align: "center",
  },
  {
    title: "Tên loại thẻ",
    dataIndex: "tenLoaiThe",
    show: true,
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    show: true,
    align: "left",
    render: (v, r, i) => STATUS_CARD.find((it) => it.value === v)?.label || "",
  },
  {
    title: "Số lượt bán",
    dataIndex: "soLuotBan",
    show: true,
    align: "center",
  },
  // {
  //   title: "Thao tác",
  //   dataIndex: "action",
  //   show: true,
  //   align: "center",
  // },
];

const paymentInfo: any = [
  // {
  //   type: SELECT,
  //   name: "hinhThucThanhToan",
  //   label: "Hình thức thanh toán",
  //   options: [
  //     {value: 0, label: "Tiền mặt"},
  //     {value: 1, label: "Chuyển khoản"},
  //     {value: 2, label: "Quẹt thẻ"},
  //   ],
  //   ...cssProps,
  // },
  {
    type: CURRENCY,
    name: "soTien",
    label: "Số tiền",
    rules: [
      { required: true, message: "Số tiền là bắt buộc!" },
      // {
      //   validator: async (_, value) => {
      //     await validateMaxMin("min", value, 0);
      //   },
      //   message: "Số tiền phải lớn hơn 0",
      // },
    ],
    disabled: true,
    ...cssProps,
  },
  {
    type: CURRENCY,
    label: "Số tiền miễn giảm",
    name: "soTienMienGiam",
    ...cssProps,
  },
  {
    type: CURRENCY,
    name: "thanhTien",
    label: "Thành tiền",
    disabled: true,
    ...cssProps,
  },
  {
    type: INPUT,
    label: "Lý do miễn giảm",
    name: "lyDoMienGiam",
    ...cssProps,
  },
  {
    type: AUTO_COMPLETE,
    label: "Người bán thẻ",
    name: "nguoiBan",
    rules: [{ required: true, message: "Vui lòng chọn người bán" }],
    ...cssProps,
  },
];
const columnsHinhThucTT: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },

  {
    type: COMBO_BOX,
    dataIndex: "idHinhThucThanhToan",
    key: "idHinhThucThanhToan",
    title: "Hình thức thanh toán",
    show: true,
    align: "left",
    width: 250,
    options: [
      { value: 0, label: "Tiền mặt" },
      { value: 1, label: "Chuyển khoản" },
      { value: 2, label: "Quẹt thẻ" },
    ],
  },

  {
    type: CURRENCY,
    dataIndex: "soTienGiaoDich",
    key: "soTienGiaoDich",
    title: "Số tiền",
    align: "right",
    show: true,
    width: 400,
    rules: [{ required: true, message: "Chưa nhập số tiền" }],
    // disabled: false,
  },

  {
    type: INPUT,
    dataIndex: "maGiaoDich",
    key: "maGiaoDich",
    title: "Mã giao dịch",
    show: true,
    autoFocus: false,
    width: 150,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export { dataFields, cardTypesInfo, columns, paymentInfo, columnsHinhThucTT };
